import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import LINK from 'constants/link.const';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import linkTo from 'utils/links/linkTo.util';
import parseMoney from 'utils/parsers/parseMoney.util';

import Footer from 'activity/components/ItemFooter';

import CN from './OnlineVoucherSale.module.scss';

const OnlineVoucherSale = ({ clientName, onReadToggle, seen: isSeen, timestamp, amount }) => {
  const { isDarkMode } = useTheme();
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();

  const handleToggleRead = useCallback(() => void onReadToggle(!isSeen), [isSeen, onReadToggle]);
  const linkVouchers = linkTo({ pattern: LINK.vouchersTracking, params: { salonId } });

  const parsedAmount = parseMoney({ value: amount });
  const displayAmount = fromAnyToInteger(parsedAmount.string);

  return (
    <div
      data-bem="OnlineVoucherSale"
      className={cn({
        'comment-content': true,
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <div
          className={cn({
            'new-item-indicator': true,
            available: !isSeen,
          })}
        />

        <div className={CN.flex}>
          <Icon variant="giftVoucher" />
          <div className={CN.title}>{t('composite.activityFeed.voucherSale.boughtVoucher', { clientName })}</div>
        </div>

        <span className={CN.text}>
          {t('composite.activityFeed.voucherSale.soldPart1')} <CurrencySign />
          {displayAmount} {t('composite.activityFeed.voucherSale.soldPart2')}
        </span>
      </div>
      <div className={CN.linkContainer}>
        <NavLink to={linkVouchers}>
          <div className={CN.link}>{t('composite.activityFeed.voucherSale.viewAllVouchers')}</div>
        </NavLink>
      </div>

      <Footer seen={isSeen} markAsRead={handleToggleRead} timestamp={timestamp} />
    </div>
  );
};

export default OnlineVoucherSale;
